//GeneratorFlag:[NoChange]
import Producer from './producer';

export default {Producer}
export{Producer}